module.exports = __webpack_public_path__ + "img/8.a606f50a.jpg";